module.exports = __webpack_public_path__ + "img/deleteBgImage.67964ab1.svg";